import { render, staticRenderFns } from "./EntryAttributes.vue?vue&type=template&id=5336bb81&scoped=true"
import script from "./EntryAttributes.vue?vue&type=script&lang=js"
export * from "./EntryAttributes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5336bb81",
  null
  
)

export default component.exports